<template>
  <div class="distributor-box">
    <!--tab栏区域-->
    <Tabs v-model="paymentStatus" :animated="false" class="tabs_styles" @on-click="changeTab">
      <TabPane v-for="item in paymentStatusList" :label="item.title" :name="item.value"></TabPane>
    </Tabs>
    <!--头部筛选区域-->
    <div class="filter-box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1004632')" prop="packagePayCodes">
              <Input type="textarea" :placeholder="$t('key1004633')" v-model.trim="pageParams.packagePayCodes"></Input>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1004634')" prop="packageCodes">
              <Input type="textarea" :placeholder=" $t('key1004631')" v-model.trim="pageParams.packageCodes"></Input>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol" v-if="paymentStatus === 'null'">
            <Form-item :label="$t('key1006170')" prop="payStatus">
              <Select v-model="pageParams.payStatus">
                <Option v-for="item in paymentStatusList" :key="item.value" :value="item.value">{{ item.title }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col style="min-width: 170px;" push="1">
            <Button @click="reset" class="mr12">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--列表区域-->
    <div class="table-box">
      <Table
        ref="selection"
        highlight-row
        border
        max-height="500"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData"
        :span-method="handleSpan">
      </Table>
    </div>
    <!--分页区域-->
    <Page
      :transfer="true"
      v-if="!tableLoading"
      :total="total"
      class="distributor-page-box"
      @on-change="changePage"
      show-total
      :page-size="pageParams.pageSize"
      show-elevator
      :current="pageParams.pageNum"
      show-sizer
      @on-page-size-change="changePageSize"
      placement="top"
      :page-size-opts="pageArray">
    </Page>
    <!--日志弹窗-->
    <commonLogModal ref="commonLog" logMode="DISTRIBUTOR">
      <h2 class="mb10">{{ $t('key1004632') + businessOrderNumber + $t('key1003201') }}</h2>
    </commonLogModal>
    <!--支付凭证弹窗-->
    <paymentVoucherModal ref="paymentVoucher" @updateData="pageParamsStatus = true"></paymentVoucherModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import commonLogModal from "@/components/common/commonLogModal.vue";
import paymentVoucherModal from "@/views/distributor/components/orderManage/paymentVoucherModal.vue";
import {amountHandel, getDataSetBatchList, getEnumList, isValueEmpty} from "@/utils/common";

export default {
  name: 'paymentManagement',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      paymentStatus: 'null',
      pageParams: {
        payStatus: 'null',
        packageCodes: null,
        packagePayCodes: null,
        pageNum: 1,
        pageSize: 15
      },
      total: 0,
      originalColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004616'),
          align: 'center',
          key: 'packagePayCode',
          minWidth: 150
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006313'),
          align: 'center',
          key: 'totalPayableAmount',
          minWidth: 150,
          render(h, params) {
            let currency = params.row.totalOrderAmountCurrency;
            let totalOrderAmount = amountHandel(params.row.totalOrderAmount);
            let price = !isValueEmpty(totalOrderAmount) ? (totalOrderAmount + ' ' + currency) : '-';
            return h('span', price);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006081'),
          align: 'center',
          key: 'payStatus',
          minWidth: 150,
          render(h, params) {
            let payStatus = params.row.payStatus;
            let text = '';
            let content = params.row.returnReason;
            v.paymentStatusList.map((item) => {
              if (Number(item.value) === payStatus) {
                text = item.title;
              }
            });
            return h('div', {class: 'flex align-items-center'}, [
              h('p', text),
              payStatus === 3 ? h('Tooltip', {
                props: {
                  transfer: true,
                  content: content,
                  maxWidth: 300,
                  placement: 'top'
                }
              }, [
                h('Icon', {
                  class: 'ml2 cursor',
                  props: {
                    type: 'ios-alert-outline',
                    size: 17,
                    color: '#FD5425'
                  }
                })
              ]) : ''
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004621'),
          key: 'businessCode',
          align: 'center',
          minWidth: 150
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003599'),
          align: 'center',
          key: 'orderAmount',
          minWidth: 150,
          render(h, params) {
            let currency = params.row.orderAmountCurrency;
            let orderAmount = amountHandel(params.row.orderAmount);
            let price = !isValueEmpty(orderAmount) ? (orderAmount + ' ' + currency) : '-';
            return h('span', price);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006314'),
          align: 'center',
          key: 'returnReason',
          width: 200,
          render: (h, params) => {
            return v.checkContentOverflow(h, params.row.returnReason, 200, 1);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          align: 'center',
          fixed: 'right',
          width: 200,
          render(h, params) {
            let payStatus = params.row.payStatus;
            let ymsPackagePayId = params.row.ymsPackagePayId;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000614'),
                    show: v.getPermission('ymsPackagePay_uploadPayVoucher') && payStatus === 1,
                    clickFn: () => {
                      v.$refs['paymentVoucher'].initPaymentVoucherData('add', params.row);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006294'),
                    show: payStatus === 4,
                    clickFn: () => {
                      v.$refs['paymentVoucher'].initPaymentVoucherData('look', params.row);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006295'),
                    show: v.getPermission('ymsPackagePay_updatePayVoucher') && payStatus === 3,
                    clickFn: () => {
                      v.$refs['paymentVoucher'].initPaymentVoucherData('update', params.row);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006293'),
                    show: v.getPermission('ymsPackagePay_updatePayVoucher') && payStatus === 2,
                    clickFn: () => {
                      v.$refs['paymentVoucher'].initPaymentVoucherData('edit', params.row);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006315'),
                    show: v.getPermission('ymsPackagePay_cancelPay') && [1, 2, 3].includes(payStatus),
                    clickFn: () => {
                      v.cancelPaymentBtn(ymsPackagePayId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002478'),
                    show: true,
                    clickFn: () => {
                      v.businessOrderNumber = params.row.packagePayCode;
                      v.$refs['commonLog'].initCommonLogData(ymsPackagePayId);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableColumns: [],
      tableData: [],
      businessOrderNumber: null,
      enumData: []
    };
  },
  computed: {
    // 付款状态
    paymentStatusList() {
      const ENUM_KEY = 'YmsPackageInfoOfflinePayStatusCoreEnum';
      let list = getEnumList(this.enumData, ENUM_KEY, 'string');
      list = list.filter((item) => item.value !== '6');
      list.unshift({
        value: 'null',
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')
      });
      return list;
    }
  },
  created() {
    this.initData();
  },
  methods: {
    // 测试数据
    async initData() {
      let enumKeyList = ['YmsPackageInfoOfflinePayStatusCoreEnum'];
      this.enumData = await getDataSetBatchList(enumKeyList);
      this.search();
    },
    // 切换Tab
    changeTab(value) {
      let v = this;
      v.$nextTick(() => {
        v.$refs['pageParams'].resetFields();
        v.pageParams.payStatus = value;
        v.pageParams.pageNum = 1;
        v.pageParamsStatus = true;
        v.$forceUpdate();
      });
    },
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.getList();
    },
    // 重置按钮
    reset() {
      let v = this;
      if (v.$refs['pageParams']) {
        v.$refs['pageParams'].resetFields();
      }
      if (v.paymentStatus === 'null') {
        v.pageParams.payStatus = 'null';
      }
      v.search();
    },
    // 参数处理
    handleParameter() {
      let v = this;
      let params = Object.assign({}, v.pageParams);
      let filterKeyList = ['packageCodes', 'packagePayCodes'];
      for (let key in params) {
        if (filterKeyList.includes(key)) {
          params[key] = v.sepCommasFn(params[key], [',', '，', '\n']);
        }
      }
      let keyList = ['payStatus'];
      for (let key of keyList) {
        params[key] = v.pageParams[key] === 'null' ? null : Number(v.pageParams[key]);
      }
      return params;
    },
    // 获取列表数据
    getList() {
      let v = this;
      v.handleColumns();
      v.tableData = [];
      v.total = 0;
      v.optionBtnWidth = [];
      if (v.getPermission('ymsPackagePay_query')) {
        v.tableLoading = true;
        v.axios.post(api.post_ymsPackagePay_query, v.handleParameter()).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              v.total = data.total;
              let list = data.list || [];
              let newList = [];
              if (list.length > 0) {
                list.map((item) => {
                  let ymsPackagePayDetails = item.ymsPackagePayDetails || [];
                  let length = ymsPackagePayDetails.length;
                  ymsPackagePayDetails.map((ele, index) => {
                    ele.orderAmount = ele.totalPrice;
                    ele.orderAmountCurrency = ele.totalPriceCurrency;
                    ele.totalOrderAmount = item.totalPrice;
                    ele.totalOrderAmountCurrency = item.totalPriceCurrency;
                    ele['length'] = length;
                    ele['currentTalg'] = (length > 1 && index === 0);
                    let obj = Object.assign({}, item, ele);
                    newList.push(obj);
                  });
                });
              }
              if (newList.length > 0) {
                newList.map((item, index) => {
                  item['tableLength'] = newList.length;
                  if (item.currentTalg) {
                    item['currentIndex'] = index;
                  }
                });
                v.tableData = newList;
                v.updateTableDom('selection');
                v.$forceUpdate();
              }
              v.tableLoading = false;
            } else {
              v.tableLoading = false;
            }
          }
        }).catch(() => {
          v.tableLoading = false;
        });
      } else {
        v.gotoError();
      }
    },
    // 处理列表字段
    handleColumns() {
      let v = this;
      v.tableColumns = [];
      let hideKeyList = [];
      if (['null'].includes(v.paymentStatus)) {
        hideKeyList = ['returnReason'];
      } else {
        hideKeyList = ['payStatus', 'returnReason'];
        if (v.paymentStatus === '3') {
          hideKeyList = ['payStatus'];
        }
      }
      v.tableColumns = v.originalColumns.filter((item) => {
        return !hideKeyList.includes(item.key);
      });
    },
    // 取消付款
    cancelPaymentBtn(ymsPackagePayId) {
      let v = this;
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006316'),
        content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006317'),
        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004292'),
        cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
        onOk: () => {
          v.axios.put(api.put_ymsPackagePay_cancelPay + `?ymsPackagePayId=${ymsPackagePayId}`, null,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000672')}).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001067'));
              v.pageParamsStatus = true;
            }
          });
        },
        onCancel: () => {

        }
      });
    },
    // 合并单元格
    handleSpan({row, column, rowIndex, columnIndex}) {
      let v = this;
      let columnList = [];
      let handleKeyList = ['packagePayCode', 'totalPayableAmount', 'payStatus'];
      if (v.tableColumns.length > 0) {
        v.tableColumns.map((item, index) => {
          if (handleKeyList.includes(item.key)) {
            columnList.push(index);
          }
        });
      }
      if (columnList.includes(columnIndex)) {
        if (row.length > 1) {
          if (rowIndex === row.currentIndex) {
            return [row.length, 1];
          } else {
            for (let i = 0; i <= row.tableLength; i++) {
              if (rowIndex === i) {
                return [0, 0];
              }
            }
          }
        }
      }
    },
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
  components: {
    commonLogModal,
    paymentVoucherModal
  }
};
</script>

<style lang="less">

</style>
